import { Checkbox } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { TYPES_DOCUMENT } from '../../../data/DataDocument';
import { DataReservation_Echeancier_Stade } from '../../../data/DataReservation_Echeancier_Stade';
import { Immocom } from '../../../specifique/immocom';
import { ComboBoxDocument } from '../../ComboBox/ComboBoxDocument';
import { ComboBoxDocumentOperationType } from '../../ComboBox/ComboBoxDocumentOperationType';
import { EUIPanel } from '../../EUI/EUIPanel';
import { ProgressIndicatorChargement } from '../../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../../Outils/MessageBars';

export class PanelRelancesEtCourriers extends Component {

    static defaultProps = {
        idOperation: undefined,
        itemsSelectionnes: [],
        /* --- */
        onDismiss: () => null,
        onEnregistrement: () => null
    };

    static defaultState = {
        courrierUniqueSiMemeAdresse: false,
        documentOperationType: undefined,
        rowGUID: undefined,
        errorMessage: "",
        warningMessage: "",
    };

    constructor(props) {
        super(props);
        this.state = { ...PanelRelancesEtCourriers.defaultState };
    };

    _onOpen = () => {
        this.setState({ ...PanelRelancesEtCourriers.defaultState });
    };

    _publiposter = () => {

        const { itemsSelectionnes, onEnregistrement } = this.props;

        if (itemsSelectionnes.length > 0) {

            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: "Génération du document en cours..."
            });

            const { rowGUID, documentOperationType, courrierUniqueSiMemeAdresse } = this.state;
            const { idDocumentOperationType } = documentOperationType;
            const reservation_Echeancier_Stades = itemsSelectionnes.map(item => ({ ...item, idStade: item.idStadeAppele }));
            DataReservation_Echeancier_Stade._onPublipostageDocumentADV(reservation_Echeancier_Stades, rowGUID, idDocumentOperationType, courrierUniqueSiMemeAdresse)
                .then(responseFetch => {
                    const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                    if (retourVerif === null) {
                        const document = responseFetch.reponseAPIobjet || {};
                        const fichier = Scriba.fichier().Base64VersByteArray(document.fileData || []);
                        Scriba.fichier().EnregisterSous(fichier, document.nom);
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, onEnregistrement);
                    }
                    else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                });
        }

    };

    render = () => {

        const { idOperation, isOpen, onDismiss } = this.props;
        const { courrierUniqueSiMemeAdresse, documentOperationType, rowGUID } = this.state;

        return <EUIPanel
            headerText="Relances et courriers"
            isFormValid={!!rowGUID}
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onSave={this._publiposter}
        >

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <MessageBars
                errorMessage={this.state.errorMessage}
                infoMessage={this.state.messageMessageBarFiltres}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            <ComboBoxDocumentOperationType
                categorie="ADV"
                itemHidden={item => !["Courriers", "Relances"].includes(item.typeDocument)}
                label="Type"
                onChange={(event, option, index, value, item) => this.setState({ documentOperationType: item, rowGUID: undefined })}
                selectedKey={documentOperationType && documentOperationType.idDocumentOperationType}
            />

            <ComboBoxDocument
                categorie="ADV"
                idOperation={idOperation}
                idSousCategorie={documentOperationType && documentOperationType.idDocumentOperationType}
                label="Fichier"
                onChange={(event, option, index, value) => { this.setState({ rowGUID: option.key }); }}
                selectedKey={rowGUID}
                type={TYPES_DOCUMENT.OPERATION}
            />

            <Checkbox
                checked={courrierUniqueSiMemeAdresse}
                disabled={!rowGUID}
                label="En cas d'adresse identique, générer un seul courrier"
                onChange={(event, checked) => this.setState({ courrierUniqueSiMemeAdresse: checked })}
                styles={{ root: { marginTop: "8px" } }}
            />

        </EUIPanel>;

    };

};